import styled from "@emotion/styled";
import { BLUE_LIGHT, OLD_BLUE } from "src/constants/colors";

const BaseTaskStatusBadge = styled.div`
  flex-shrink: 0;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
  padding: 4px;
`;

export const TaskCompletedBadge = styled(BaseTaskStatusBadge)`
  background-color: rgba(219, 248, 231, 1);
  color: rgba(1, 124, 63, 1);
`;

export const TaskInProgressBadge = styled(BaseTaskStatusBadge)`
  background-color: ${BLUE_LIGHT};
  color: ${OLD_BLUE};
`;

export const TaskToDoBadge = styled(BaseTaskStatusBadge)`
  background-color: rgba(239, 230, 217, 1);
  color: rgba(150, 89, 4, 1);
`;

export const TaskCorrectionNeededBadge = styled(BaseTaskStatusBadge)`
  background-color: rgba(246, 239, 241, 1);
  color: rgba(185, 60, 60, 1);
`;
